import { AnalyzerPodReport } from '@Models/types';
import { startOfWeek, endOfWeek, getISOWeek, format, subWeeks } from 'date-fns';

export type GroupedTickets = {
  high: AnalyzerPodReport['tickets'];
  mid: AnalyzerPodReport['tickets'];
  low: AnalyzerPodReport['tickets'];
  unclassified: AnalyzerPodReport['tickets'];
};

export function groupTicketsByConfidence(
  tickets: AnalyzerPodReport['tickets']
): GroupedTickets {
  return {
    high: tickets.filter(
      (t) =>
        t.ticket.classification &&
        t.ticket.classification.confidence_score >= 70
    ),
    mid: tickets.filter(
      (t) =>
        t.ticket.classification &&
        t.ticket.classification.confidence_score >= 30 &&
        t.ticket.classification.confidence_score < 70
    ),
    low: tickets.filter(
      (t) =>
        t.ticket.classification && t.ticket.classification.confidence_score < 30
    ),
    unclassified: tickets.filter((t) => !t.ticket.classification),
  };
}

export function getCurrentWeekRange() {
  const today = new Date();

  // Start on Monday, end on Sunday
  const monday = startOfWeek(today, { weekStartsOn: 1 }); // 1 = Monday
  const sunday = endOfWeek(today, { weekStartsOn: 1 }); // still ends on Sunday

  const week = `${monday.getFullYear()}-W${String(getISOWeek(monday)).padStart(2, '0')}`;
  const duration = `${format(monday, 'yyyy-MM-dd')} to ${format(sunday, 'yyyy-MM-dd')}`;

  return { week, duration };
}

export function getPreviousWeekRange() {
  const today = new Date();

  // Move one week back
  const lastWeek = subWeeks(today, 1);

  // Start on Monday, end on Sunday for the previous week
  const monday = startOfWeek(lastWeek, { weekStartsOn: 1 });
  const sunday = endOfWeek(lastWeek, { weekStartsOn: 1 });

  const week = `${monday.getFullYear()}-W${String(getISOWeek(monday)).padStart(2, '0')}`;
  const duration = `${format(monday, 'yyyy-MM-dd')} to ${format(sunday, 'yyyy-MM-dd')}`;

  return { week, duration };
}
